//react-components
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

//Componets
import AddOrUpdateUser from "./AddOrUpdateUser";

//Custom UI Cmponents
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";

//Utils
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";

//Actions
import {
  createUserAction,
  updateUserAction,
  deactivateUserAction,
  handleUploadPhotoAction,
  getProfilePhotoAction,
} from "./AddOrUpdateUserAction";
import { setLoginDetails, setProfileImage } from "../Login/LoginAction";
import {
  saveUserDetailsAction,
  getUserRolesAction,
} from "../UserList/UserListAction";
import { setSearchFilterAction } from "../redux/Action";
import { saveUserName } from "../AuditTrail/AuditTrailAction";

//Constants
import {
  API_RESPONSE_STATUS_CODES,
  SEARCH_FILTER_PAGES,
  USER_LIST_FILTER,
} from "../Utils/Constants";
import {
  defaultObjForAddOrUpdateUser,
  DEFAULT_USER_SELECTION,
} from "./Constants";

//Strings
import { Strings } from "../Translations/i18n";

class AddOrUpdateUserContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      createUserSuccess: false,
      updateUserSuccess: false,
      profilePicUrl: null,
      moderators: [],
      showLoadingModal: false,
      toShowToast: false,
      message: "",
      level: "",
      userRoles: props.userRoles,
    };
  }

  componentDidMount() {
    this.getRoles();
  }
  componentWillUnmount() {
    if (
      this.props.searchPage === SEARCH_FILTER_PAGES.USER_LIST &&
      this.props.history.location.pathname !==
        APPLICATION_CONFIGURATIONS.path.userDetails
    ) {
      this.props.setSearchFilterAction(SEARCH_FILTER_PAGES.USER_LIST, {
        ...USER_LIST_FILTER,
      });
    }
  }

  getRoles = () => {
    if (
      this.props.loginReducer.authority === "ADMIN" ||
      this.props.loginReducer.authority === "GENERAL_MANAGER"
    ) {
      this.props.getUserRolesAction((responseData) => {
        let userRoles = responseData.data.roles;
        userRoles.unshift({ id: 0, role: DEFAULT_USER_SELECTION });
        this.setState({ userRoles });
      });
    } else {
      let userRole = [];
      userRole.push({ role: this.props.loginReducer.authority });
      this.setState({ userRoles: userRole });
    }
  };

  //Go to user list on clcik of back
  onBackClick = () => {
    this.props.history.goBack();
  };
  //Callback to handle Create user
  handleCreateUser = (userDetails, file) => {
    this.setState({
      showLoadingModal: true,
      toShowToast: false,
      message: "",
      level: "",
    });

    createUserAction(userDetails, (responseData) => {
      if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        this.props.saveUserDetailsAction(userDetails);
        if (file) {
          this.handleUploadPhoto(userDetails.username, file);
        } else {
          this.setState({
            errorMessage: "",
            toShowToast: true,
            message: Strings("userCreatedSuccessfully"),
            level: "success",
            showLoadingModal: false,
          });
          this.onBackClick();
        }
      } else if (
        responseData.status === API_RESPONSE_STATUS_CODES.USERNAME_ALREADY_EXIST
      ) {
        this.setState({
          errorMessage: Strings("errorUsernameAlreadyExist"),
          showLoadingModal: false,
        });
      } else if (
        responseData.status === API_RESPONSE_STATUS_CODES.ROLE_NOT_FOUND
      ) {
        this.setState({
          errorMessage: Strings("errorRoleNotFound"),

          showLoadingModal: false,
        });
      } else if (
        responseData.status === API_RESPONSE_STATUS_CODES.INVALID_EMAIL_ID
      ) {
        this.setState({
          errorMessage: Strings("errorEmailIdNotExist"),
          showLoadingModal: false,
        });
      }
    });
  };
  //Callback to handle Update user
  handleUpdateUser = (userDetails, file, avatar) => {
    this.setState({
      showLoadingModal: true,
      toShowToast: false,
      message: "",
      level: "",
    });

    updateUserAction(userDetails, (responseData) => {
      if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        this.props.saveUserDetailsAction(userDetails);

        if (this.props.loginReducer.userName === userDetails.username) {
          this.props.setLoginDetails({
            firstName: userDetails.firstName,
            lastName: userDetails.lastName,
          });
        }
        if (file) {
          this.handleUploadPhoto(userDetails.username, file, avatar);
        } else {
          this.setState({
            errorMessage: "",
            toShowToast: true,
            message: Strings("userUpdatedSuccessfully"),
            level: "success",
            showLoadingModal: false,
          });
        }
      } else if (
        responseData.status === API_RESPONSE_STATUS_CODES.USERNAME_ALREADY_EXIST
      ) {
        this.setState({
          errorMessage: Strings("errorUsernameAlreadyExist"),
          showLoadingModal: false,
        });
      } else if (
        responseData.status === API_RESPONSE_STATUS_CODES.ROLE_NOT_FOUND
      ) {
        this.setState({
          errorMessage: Strings("errorRoleNotFound"),
          showLoadingModal: false,
        });
      }
    });
  };
  //Callback to handle Deactivate user
  handleDeactivateUser = (userDetails) => {
    this.setState({ showLoadingModal: true });

    deactivateUserAction(userDetails, (responseData) => {
      if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        this.setState(
          {
            errorMessage: "",
            showLoadingModal: false,
          },
          () => {
            this.props.history.push(APPLICATION_CONFIGURATIONS.path.userList);
          }
        );
      }
    });
  };

  //Callback to handle upload profile pic
  handleUploadPhoto = (username, profilePhoto, avatar) => {
    this.setState({
      showLoadingModal: true,
      toShowToast: false,
      message: "",
      level: "",
    });
    handleUploadPhotoAction(username, profilePhoto, (responseData) => {
      if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        this.setState({
          errorMessage: "",
          showLoadingModal: false,
          toShowToast: true,
          message: avatar
            ? Strings("userUpdatedSuccessfully")
            : Strings("userCreatedSuccessfully"),
          level: "success",
        });
        !avatar && this.onBackClick();

        // dump data in login Reducer
        if (this.props.loginReducer.userName === username) {
          this.props.setProfileImage(avatar);
        }
      }
    });
  };

  //Callback to handle get profile pic
  getProfilePhoto = (username) => {
    this.setState({ showLoadingModal: true });

    getProfilePhotoAction(username, (responseData) => {
      if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        this.setState({
          errorMessage: "",
          profilePicUrl: responseData.data.s3Url,
          showLoadingModal: false,
        });
      } else {
        this.setState({ profilePicUrl: null, showLoadingModal: false });
      }
    });
  };

  redirectToAudit = (auditType) => {
    this.props.saveUserName({
      userName: this.props.userDetails.username,
      auditType: auditType,
      performedOn:
        this.props.userDetails.username === this.props.loginReducer.userName
          ? this.props.loginReducer.userId
          : this.props.userDetails.id,
    });
    this.props.history.push(APPLICATION_CONFIGURATIONS.path.auditTrail);
  };

  render() {
    //Passed selected user to component through props
    return (
      <div>
        <LoadingModal showLoadingModal={this.state.showLoadingModal} />
        {this.state.toShowToast && (
          <UserNotification
            userNotificationObj={{
              message: this.state.message,
              level: this.state.level,
              title: this.state.level === "success" ? "Success !" : "Errorr !",
            }}
          />
        )}

        <AddOrUpdateUser
          selectedUser={
            JSON.stringify(this.props.userDetails) ===
            JSON.stringify(defaultObjForAddOrUpdateUser)
              ? defaultObjForAddOrUpdateUser
              : this.props.userDetails
          }
          // handleType={this.handleType}
          loginReducer={this.props.loginReducer}
          userRoles={this.state.userRoles}
          handleCreateUser={this.handleCreateUser}
          handleUpdateUser={this.handleUpdateUser}
          handleDeactivateUser={this.handleDeactivateUser}
          onBackClick={this.onBackClick}
          errorMessage={this.state.errorMessage}
          handleUploadPhoto={this.handleUploadPhoto}
          getProfilePhoto={this.getProfilePhoto}
          profilePicUrl={this.state.profilePicUrl}
          title={
            this.props.location.pathname ===
            APPLICATION_CONFIGURATIONS.path.userDetails
              ? "userDetails"
              : "profileDetails"
          }
          moderators={this.state.moderators}
          getUserList={this.getUserList}
          redirectToAudit={this.redirectToAudit}
        />
      </div>
    );
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveUserDetailsAction: saveUserDetailsAction,
      createUserAction: createUserAction,
      updateUserAction: updateUserAction,
      deactivateUserAction: deactivateUserAction,
      handleUploadPhotoAction: handleUploadPhotoAction,
      getProfilePhotoAction: getProfilePhotoAction,
      setLoginDetails: setLoginDetails,
      setProfileImage: setProfileImage,
      getUserRolesAction: getUserRolesAction,
      setSearchFilterAction: setSearchFilterAction,
      saveUserName: saveUserName,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    userDetails: state.UserReducer.userDetails,
    userRoles: state.UserReducer.userRoles,
    loginReducer: state.loginReducer,
    searchPage: state.searchFilterReducer.searchPage,
  };
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(AddOrUpdateUserContainer);
